export default {"src":"/canvas/_next/static/media/icon-office365-t5.4c0ba4ff.svg","height":2500,"width":2075,"blurWidth":0,"blurHeight":0};